<template>
	<section>
		<header v-if="trainingList.length > 0">
			szkolenia
			<router-link to="/Training">zobacz wszystkie</router-link>
		</header>
		<div
			v-for="training in trainingList"
			:key="training.id"
			class="training-item"
		>
			<p>
				<span>
					<img src="images/clock-gray.svg" width="14" />
				</span>
				<span> {{ $filters.time(training.trainingDate) }}</span>
				<span>
					{{ training.dayOfWeek }}
					<template
						v-if="
							windowWidth >= mobileBreakpoint &&
							windowWidth <= 1349
						"
					>
						<br />
						<span style="margin-right: 2px"></span>
					</template>
				</span>
				<span>{{ $filters.date(training.trainingDate) }}</span>
				<template v-if="training.canRegister === 1">
					<button
						type="button"
						@click="showTrainingModal(training)"
						:class="[
							'btn-link-inline float-right',
							{
								tablet:
									windowWidth >= mobileBreakpoint &&
									windowWidth <= 1349,
							},
						]"
					>
						Zapisz się
					</button>
				</template>
				<template v-if="training.canRegister === 2">
					<span
						:class="[
							'float-right',
							{
								tablet:
									windowWidth >= mobileBreakpoint &&
									windowWidth <= 1349,
							},
						]"
						>Zarejestrowany</span
					>
				</template>
			</p>
			<router-link to="/Training" style="text-decoration: none">
				<h4
					v-html="trunkateString(training.name)"
					style="text-decoration: none; color: #201c17"
				></h4>
			</router-link>
			<p v-html="trunkateString(training.description)"></p>
			<p>Prowadzący: {{ training.trainerName }}</p>
		</div>
		<training-registration-notification
			v-if="$store.getters.getDisplayRegistrationModal"
			:info="dataForNotification"
		/>
	</section>
</template>

<script>
import TrainingRegistrationNotification from '@/views/training/partial/_TrainingRegistrationNotification';
import { stringFunctions } from '@/mixins/string-functions.js';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			dataForNotification: {},
		};
	},
	mixins: [stringFunctions],
	components: {
		TrainingRegistrationNotification,
	},
	methods: {
		showTrainingModal(training) {
			this.$store.dispatch('postTrainingRegistration', training.id);
			this.dataForNotification = training;
		},
	},
	computed: {
		trainingList() {
			return this.$store.getters.getTrainingList
				? this.$store.getters.getTrainingList.slice(0, 3)
				: [];
		},
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		...mapGetters({
			mobileBreakpoint: 'getMobileBreakpoing',
		}),
	},
};
</script>

<style scoped>
.tablet {
	margin-top: -19px;
}
</style>
